import ExpandableTable, { ExpandChevron } from "../ui/ExpandableTable";
import { DASH, merColor, pct, visibleGroups } from "./columns";

function weekLabel(iso) {
  const start = new Date(`${iso}T00:00:00`);
  const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);
  const opts = { day: "numeric", month: "short" };
  return `${start.toLocaleDateString("en-GB", opts)} – ${end.toLocaleDateString("en-GB", opts)}`;
}

function dayLabel(iso) {
  return new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}

function ProductList({ row, count }) {
  const products = (row.products || []).slice(0, count);
  if (products.length === 0) return DASH;
  return (
    <span className="flex flex-col gap-0.5">
      {products.map((p) => (
        <span key={p.title} className="flex gap-2 justify-between">
          <span className="truncate max-w-[220px]">{p.title}</span>
          <span className="text-collectors-gray tabular-nums">{pct(p.share, 0)}</span>
        </span>
      ))}
    </span>
  );
}

export default function WeeklyTable({ weeks, expansion, hidden, productCount }) {
  /** What goes inside one cell. The three special cases all concern the first
      column or the product list; everything else is a plain formatter. */
  function renderCell(col, row, { open, isChild }) {
    if (col.key === "products") return <ProductList row={row} count={productCount} />;
    if (col.key !== "period") return col.render(row);
    if (isChild) {
      return (
        <span className="pl-6 inline-block text-collectors-gray">{dayLabel(row.period)}</span>
      );
    }
    return (
      <span className="flex items-center gap-2">
        <ExpandChevron open={open} />
        {weekLabel(row.period)}
        {row.partial && <span className="text-[10px] uppercase tracking-widest">partial</span>}
      </span>
    );
  }

  function rowClassName(row, { open, isChild, col }) {
    return [
      col.key === "mer" ? `${merColor(row.mer, open)} font-bold` : "",
      row.partial && !open && !isChild ? "text-collectors-gray italic" : "",
    ].join(" ");
  }

  return (
    <ExpandableTable
      groups={visibleGroups(hidden)}
      rows={weeks}
      rowKey={(row) => row.period}
      renderCell={renderCell}
      rowClassName={rowClassName}
      expansion={{
        open: expansion.openWeeks,
        children: expansion.days,
        loading: expansion.loadingWeeks,
        errors: expansion.errors,
        onToggle: expansion.onToggle,
      }}
      emptyLabel="No weeks in this time range."
      childEmptyLabel="No days with data in this week."
    />
  );
}
